module.exports = __webpack_public_path__ + "img/bg-svip-left.a4d88b0f.png";